import React, { ReactNode, useState } from "react";
import styles from '../LinkPersonalizado/linkPersonalizado.module.scss';

interface LinkPersonalizadoProps {
    href: string;
    title: string;
    icon: ReactNode;
    showIcon?: boolean;
    colorText: string;
    tipo?: string;

}

const LinkPersonalizado: React.FC<LinkPersonalizadoProps> = ({
    href,
    title,
    icon,
    showIcon = true,
    colorText,
    tipo = "padrao",
}) => {
    return (
        <a
            href={href}
            target="_blank"
            rel="noreferrer"
            style={
                tipo == "rosa" ? {
                    background: `
                      radial-gradient(ellipse at 80% 90%, 
                        #FFD1DC 0%, 
                        #FFB6C1 8%, 
                        #FF8FAB 30%, 
                        #E75480 40%, 
                        rgba(255, 255, 255, 0) 80%), 
                      radial-gradient(ellipse at 20% 10%, 
                        #FFFFFF 0%, 
                        #FFE4EC 8%, 
                        #FADADD 25%, 
                        #D46A92 62.5%, 
                        #D46A92 100%)`,
                    transition: "background 0.5s ease",
                    position: "relative",
                }
                    :
                    {
                        background: `
                radial-gradient(ellipse at 80% 90%, 
                  #FFEF9A 0%, 
                  #FDD875 8%, 
                  #edd282 30%, 
                  #d6ad58 40%, 
                  rgba(255, 255, 255, 0) 80%), 
                radial-gradient(ellipse at 20% 10%, 
                  #FFFFFF 0%, 
                  #FFF9CC 8%, 
                  #EAD69C 25%, 
                  #8B7040 62.5%, 
                  #8B7040 100%)`,
                        transition: "background 0.5s ease",
                        position: "relative", // Necessário para o posicionamento absoluto do ícone
                    }
            }
        >
            {showIcon && <div className={tipo == "rosa" ? styles["div-icon-tipo-rosa"] : styles["div-icon"]}>{icon}</div>}
            <div className="d-flex align-items-center justify-content-center">
                <div className={styles["min-w-span"]}>
                    {title == "Agendar Consultas Voucher" ?
                        <>
                            <span className={styles["span"]} style={{ color: colorText }}>Agendar Consultas</span>
                            <span style={{ color: colorText }}> / </span>
                            <span className={styles["span"]} style={{ color: colorText }}>Voucher</span>
                        </>
                        :
                        <span className={styles["span"]} style={{ color: colorText }}>{title}</span>
                    }
                </div>
            </div>
        </a>

    );
};

export default LinkPersonalizado;
